import { ThumbUpAltOutlined } from "@mui/icons-material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import { Box, styled, Typography } from "@mui/material";
import { shouldForwardProp } from "../../common/Common.style";
import theme from "../../theme";

export const AcknowledgeHeader = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<StyleBoxProps>(["isAcknowledged"], prop),
})<StyleBoxProps>(({ isAcknowledged }) => ({
  background: isAcknowledged
    ? `${theme.palette.success.main}`
    : `${theme.palette.primary.main}`,
  borderRadius: "inherit",
  variant: "h3",
  margin: 3,
  color: `${theme.palette.background.default}`,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  lineHeight: 0.8,
  padding: 5,
  svg: {
    marginRight: 10,
  },
}));

export const AcknowledgeFooter = styled(Typography, {
  shouldForwardProp: prop =>
    shouldForwardProp<StyleBoxFooterProps>(
      ["hasUserAcknowledged", "isSelf", "disableActions"],
      prop,
    ),
})<StyleBoxFooterProps>(({ hasUserAcknowledged, isSelf, disableActions }) => ({
  borderRadius: "inherit",
  margin: 3,
  color:
    !hasUserAcknowledged && !isSelf
      ? `${theme.palette.primary.main}`
      : `${theme.palette.common.white}`,
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  lineHeight: 1,
  paddingTop: 3,
  paddingBottom: 3,
  paddingLeft: 3,
  paddingRight: 8,
  cursor:
    !disableActions && !hasUserAcknowledged && isSelf ? "pointer" : "default",
  svg: {
    marginRight: 10,
  },
  backgroundColor:
    !hasUserAcknowledged && isSelf
      ? `${theme.palette.primary.main}`
      : hasUserAcknowledged
        ? `${theme.palette.success.main}`
        : undefined,
}));

export const ThumbsUpIcon = styled(ThumbUpIcon)`
  margin-left: 6px;
  height: 18px;
  width: 18px;
`;

export const ThumbsUpAltOutlined = styled(ThumbUpAltOutlined)`
  margin-left: 6px;
  height: 18px;
  width: 18px;
`;

export const MoreAcknowledgeWrapper = styled(Box)`
  cursor: pointer;
`;

export const MoreAcknowledgeLabel = styled(Typography)`
  margin-top: 14px;
  margin-left: 12px;
  color: ${theme.palette.primary.main};
  line-height: 0.6;
`;

type StyleBoxProps = {
  isAcknowledged?: boolean;
};

type StyleBoxFooterProps = {
  hasUserAcknowledged?: boolean;
  isSelf?: boolean;
  disableActions?: boolean;
};
